import { useDispatch } from "react-redux"
import { DropdownSearchBar } from "../DropdownSearchBar/DropdownSearchBar"
import { NavbarSearchActions } from "shared/reducers/NavbarSearch"
import { useCallback } from "react";


export const MainSearchController = () => {
    const dispatch = useDispatch();

    const onClose = useCallback(() => {
        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }))
    }, [dispatch])
    

    return <DropdownSearchBar autoOpen orientation={'right'} onClose={onClose} />
}import { useDispatch } from "react-redux"
import { DropdownSearchBar } from "../DropdownSearchBar/DropdownSearchBar"
import { NavbarSearchActions } from "shared/reducers/NavbarSearch"
import { useCallback } from "react";


export const MainSearchController = () => {
    const dispatch = useDispatch();

    const onClose = useCallback(() => {
        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }))
    }, [dispatch])
    

    return <DropdownSearchBar autoOpen orientation={'right'} onClose={onClose} />
}